export default __webpack_public_path__ + "4daa4e779b99467bcf22f43205992279.png";